export default __webpack_public_path__ + "static/Energia-bac2528d36b76b392eddb587ea2ce59f.svg";